module.exports = __webpack_public_path__ + "assets/img/logo_mastercad.4106de99.svg";